import styled from "styled-components";

export const Wrapper = styled.div`
  background-color: transparent;
  padding: 18px 24px;
`;
